import React from 'react';
import { Button, Table, TableHead, TableRow, TableCell, Typography, } from '@one-thd/sui-atomic-components';
import { useAddManageUsers } from '../../hooks/use-add-manage-users';
import { AccountTableContent } from './table-perms/accounts';
import { PerksTableContent } from './table-perms/perks';
import { QuotesAndOrdersTableContent } from './table-perms/quotes-and-orders';
import { PaymentMethodsTableContent } from './table-perms/payment-methods';
import { PurchasingTableContent } from './table-perms/purchasing';
export var ManageUsersTable = function (_a) {
    var role = _a.role, onClick = _a.onClick;
    var isPartOfRunnerAllowance = useAddManageUsers().isPartOfRunnerAllowance;
    var handleClick = function (userRole) {
        onClick(userRole);
    };
    var adminStyling = isPartOfRunnerAllowance ? 'sui-py-2 sm:sui-py-0' : '';
    return (React.createElement("div", { className: "sui-w-full sui-overflow-y-auto sui-no-scrollbar" },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { sticky: "horizontal" }, "Permissions"),
                    React.createElement(TableCell, { align: "center", width: "full" },
                        React.createElement(Typography, { align: "center", variant: "h6" }, "Admin"),
                        React.createElement("div", { className: adminStyling },
                            React.createElement(Typography, { align: "center", variant: "body-xs" }, "Full Access and Control")),
                        React.createElement("div", null,
                            React.createElement(Button, { "data-testid": "adminBtn", disabled: role === 'Admin', type: "button", variant: "secondary", fullWidth: true, onClick: function () {
                                    handleClick('Admin');
                                } }, "Select"))),
                    React.createElement(TableCell, { align: "center" },
                        React.createElement(Typography, { align: "center", variant: "h6" }, "Purchaser"),
                        React.createElement("div", { className: "" },
                            React.createElement(Typography, { align: "center", variant: "body-xs" }, "Limited access for ordering")),
                        React.createElement("div", null,
                            React.createElement(Button, { "data-testid": "purchaserBtn", disabled: role === 'Purchaser', type: "button", variant: "secondary", fullWidth: true, onClick: function () {
                                    handleClick('Purchaser');
                                } }, "Select"))),
                    isPartOfRunnerAllowance && (React.createElement(TableCell, { align: "center" },
                        React.createElement(Typography, { align: "center", variant: "h6" }, "Runner"),
                        React.createElement("div", { className: "" },
                            React.createElement(Typography, { align: "center", variant: "body-xs" }, "Minimal access for purchases")),
                        React.createElement("div", null,
                            React.createElement(Button, { "data-testid": "runnerBtn", disabled: role === 'Runner', type: "button", variant: "secondary", fullWidth: true, onClick: function () {
                                    handleClick('Runner');
                                } }, "Select")))))),
            React.createElement(PurchasingTableContent, { isEnrolled: isPartOfRunnerAllowance }),
            React.createElement(PaymentMethodsTableContent, { isEnrolled: isPartOfRunnerAllowance }),
            React.createElement(QuotesAndOrdersTableContent, { isEnrolled: isPartOfRunnerAllowance }),
            React.createElement(PerksTableContent, { isEnrolled: isPartOfRunnerAllowance }),
            React.createElement(AccountTableContent, { isEnrolled: isPartOfRunnerAllowance }))));
};
